import { Col, H2, Image, Row } from '@ahmdigital/ui';
import { map, startCase } from 'lodash/fp';
import React from 'react';

import citydentalImage from './images/citydental.png';
import constants from '../../../../../../../ahm-constants';
import crottydentalImage from './images/crottydental.png';
import danieltanImage from './images/danieltan.png';
import dbdentalImage from './images/dbdental.png';
import easternshoredentalImage from './images/easternshoredental.jpg';
import nationaldentalcareImage from './images/nationaldentalcare.png';
import pacificsmilesImage from './images/pacificsmiles.jpg';
import styles from './styles.module.sass';
import uncapFpIterator from '../../../../../../../../utils/uncap-fp-iterator';

const logos = {
  cityDental: {
    cssClass: 'city',
    img: <Image alt="City Dental" src={citydentalImage.src} />,
  },
  crottyDental: {
    cssClass: 'logo',
    img: <Image alt="Crotty Dental" src={crottydentalImage.src} />,
  },
  danielTan: {
    cssClass: 'danielTan',
    img: <Image alt="Daniel Tan" src={danieltanImage.src} />,
  },
  dbDental: {
    cssClass: 'logo',
    img: <Image alt="Db Dental" src={dbdentalImage.src} />,
  },
  easternShoreDental: {
    cssClass: 'logo',
    img: <Image alt="Eastern Shore Dental" src={easternshoredentalImage.src} />,
  },
  nationalDentalCare: {
    cssClass: 'logo',
    img: <Image alt="National Dental Care" src={nationaldentalcareImage.src} />,
  },
  pacific: {
    cssClass: 'logo',
    img: <Image alt="Pacific Smiles Dental" src={pacificsmilesImage.src} />,
  },
};

const STATE_LOGO_MAP = {
  [constants.STATE.ACT]: [logos.pacific],
  [constants.STATE.NSW]: [logos.pacific],
  [constants.STATE.NT]: [logos.nationalDentalCare],
  [constants.STATE.QLD]: [logos.pacific],
  [constants.STATE.SA]: [logos.nationalDentalCare],
  [constants.STATE.TAS]: [logos.crottyDental, logos.cityDental, logos.danielTan, logos.easternShoreDental],
  [constants.STATE.VIC]: [logos.pacific],
  [constants.STATE.WA]: [logos.dbDental],
};

type StateDentistLogoProps = {
  state: string;
};

const StateDentistLogo = ({ state }: StateDentistLogoProps) => (
  <div className={styles.container}>
    <H2 looksLike="h5" variant="regular">
      Participating dentists in {startCase(state)}
    </H2>
    <Row lgHorizontalAlign="left" smHorizontalAlign="center">
      {uncapFpIterator(map)(
        // @ts-expect-error - Automatic, Please fix when editing this file
        ({ img, cssClass }, index) => (
          <Col variant={[styles.column, styles[cssClass]]} xs={12} df key={index}>
            {img}
          </Col>
        ),
        // @ts-expect-error - Automatic, Please fix when editing this file
        STATE_LOGO_MAP[state],
      )}
    </Row>
  </div>
);

export default StateDentistLogo;
